export const GET_AVAILABILITY_STORES_ENDPOINT = '/Catalog/GetAvailablityStores';
